angular.module('st')
    .controller('GiftCardController', [
        '$rootScope', '$scope', '$http', 
        function ($rootScope, $scope, $http) {
            var ctrl = this;

            $scope.cardBalance = '';
            $scope.feedback = '';
            $scope.processing = false;

            $('input[name="cardNumber"]').on('keypress change', function () {
                $(this).val(function (index, value) {
                    return value.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ');
                });
                $(this).val($(this).val().length > 19 ? $(this).val().trim() : $(this).val());
            });

            ctrl.CheckBalance = function () {
                grecaptcha.ready(function() {
                  grecaptcha.execute($('#captcha-site-key').val(), {action: ''}).then(function(token) {
                        if ($scope.processing == false) {
                            $scope.processing = true; 
                            $scope.feedback = 'Checking balance...';
                            $scope.cardBalance = '';

                            const formattedCardNumber = $scope.cardNumber.split(' ').join('');
                            $http.post("/rpc/order/giftcard/balance",
                            {
                                cardNumber : formattedCardNumber,
                                pinNumber : $scope.pinNumber,
                                captchaToken : token
                            }).then(function (data) {

                                if (data.data.Success == true) {
                                    console.log(data.data.Data.Balance);
                                    $scope.cardBalance = data.data.Data.Balance;
                                    $scope.feedback = '';
                                    $scope.processing = false;
                                } else {
                                    // vista error
                                    $scope.processing = false;
                                    $scope.feedback = 'Error: ' + data.data.Message;
                                }
                            }).catch(function (error) {
                                console.log('error', error);
                                // our server error
                                $scope.processing = false;
                                $scope.feedback = 'Error occurred while trying to check balance.'
                            })
                        }
                  });
                });
            }

            ctrl.IsFieldInvalid = function (field) {
                return field.$invalid && (field.$touched || $scope.frm.$submitted);
            }
        }
    ]);
